import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LdsUserService } from '../../services/lds-user.service';
import { map } from 'rxjs/operators';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { IconsService } from '../../services/icons.service';
import { DataAnalyticsService } from '../../data-analytics/data-analytics.service';
import { DataExportService } from '../../services/data-export.service';
import { PopupComponent } from '../../common-components/popup/popup.component';
import { time } from '../../services/global-variables.service';
import { TimeSelectComponent } from '../../time-select/time-select.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'lds-motion-sensor',
    templateUrl: './motion-sensor.component.html',
    styleUrls: ['./motion-sensor.component.css'],
    standalone: false
})
export class MotionSensorComponent implements OnInit {


  public featureSet : any;
  public features: any;
  public timespan: string;
  public deviceType: string;
  public icon_margin;
  public hasNoData: boolean = false;
  public daily_data: any;
  public startTime: number;
  public endTime: number;

  public room;

  private featuresToShow = ['dimLevel', 'switch', 'movement', 'energy', 'power',
  'temperature', 'targetTemperature'/*, 'batteryLevel'*/, 'buttonPress', 'windowPosition', 'valveLevel', 'switch', 'lightLevel', 'batteryLevel'];

  constructor(private user: LdsUserService, private dialog: MatDialog, private route: ActivatedRoute, private eventBus: LdsEventBusService, public icons: IconsService, private dataAnalytics: DataAnalyticsService, private dataExport: DataExportService, private popup: PopupComponent) { }

  ngOnInit() {
    this.timespan = 'weekly';
    this.route.params.pipe(map(params => params['id'])).subscribe((id) => {
      this.eventBus.subscribe('energy-featureSets-loaded-from-storage', () => {

        this.featureSet = this.user.motionFeatureSets[id];

          this.user.currentModule = this.featureSet.name;
          this.room = this.user.getRoom(this.featureSet);
          if(this.room){
              this.user.currentModule = this.featureSet.name + " - " + this.room.name; 
          }
          this.showGraph(this.featureSet);
      });
  });
  }

  private async showGraph(featureSet){
    this.featureSet = featureSet;
    let featuresBuffer = [];
    let motionFeature;
    for (let index = 0; index < featureSet.features.length; index++) {
        const element = this.user.features[featureSet.features[index]];
        if (this.featuresToShow.indexOf(element.attributes.type) >= 0) {
            featuresBuffer.push(element);
            if(element.attributes.type === "movement"){
              motionFeature = element;
            }
        }
    }


    if(!motionFeature){
      this.hasNoData = true;
      this.user.loading = false;
      return;
    }

    this.deviceType = featureSet.type;
    this.features = featuresBuffer;

    let dataRequired = true;

    switch(this.timespan){
      case "weekly":
        dataRequired = !featureSet.daily_data;
        this.endTime = new Date().getTime();
        this.startTime = this.endTime - time.day * 7;
        break;
      case "monthly":
        dataRequired = !featureSet.monthly_data;
        this.endTime = new Date().getTime();
        this.startTime = this.endTime - time.day * 30;
        break;
      case "custom":
        dataRequired = true;
        let res: any = await this.dialog.open(TimeSelectComponent).afterClosed().toPromise();
          if(!res.timeSelected){
            return;
          }
          this.startTime = res.startDate.getTime();
          this.endTime = res.endDate.getTime();
        break;    
    }


    if(dataRequired){
      this.dataAnalytics.getFeatureRawDateRange(motionFeature.featureId, this.dataAnalytics.getDaysBetween(this.startTime, this.endTime), this.startTime, this.endTime).subscribe(result => {
        switch(this.timespan){
          case "weekly":
            this.featureSet.daily_data = result;
            break;
          case "monthly":
            this.featureSet.monthly_data = result;  
            break;
        }

        this.daily_data = result;

        this.eventBus.broadcast("motion-data-loaded", true);
        this.eventBus.startSubscribe("motion-data-loaded", (called) => {
          if(called && !this.daily_data || this.daily_data.length === 0) {
            this.hasNoData = true;
            return;
          }
          this.hasNoData = false;
    
        });
      });



    } else {
      switch(this.timespan){
        case "weekly":
          this.daily_data = featureSet.daily_data;
          break;
        case "monthly":
          this.daily_data = featureSet.monthly_data;
          break;
      }
      if(!this.daily_data || this.daily_data.length === 0) {
        this.hasNoData = true;
        return;
      }
    }
  
  }

  changeTimeSpan(timespan: string){
    this.timespan = timespan;
    this.showGraph(this.featureSet);
  }

  displayProductCode(productCode) {
    return this.icons.getProductCodeDisplay(productCode);
  }

  onExportClick(){
    this.popup.open().afterClosed().subscribe(res => {
      this.dataExport.exportData(this.featureSet, this.daily_data, res);
    });
  }

}
